// import { defaultNetworkService } from '../../../../../services/network'
import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../../utils/queryParams.js";
export const SET_LOADING = "saga/SET_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const UPDATE_ALL_DATA = "saga/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA_FAILURE = "saga/UPDATE_ALL_DATA_FAILURE";
export const FETCH_FOLLOW_UPS = "saga/FETCH_FOLLOW_UPS";
export const FETCH_FOLLOW_UPS_SUCCESS = "saga/FETCH_FOLLOW_UPS_SUCCESS";
export const FETCH_FOLLOW_UPS_FAILURE = "saga/FETCH_FOLLOW_UPS_FAILURE";
export const FETCH_NEARLY_EXHAUSTED = "saga/FETCH_NEARLY_EXHAUSTED";
export const FETCH_NEARLY_EXHAUSTED_SUCCESS = "saga/FETCH_NEARLY_EXHAUSTED_SUCCESS";
export const FETCH_NEARLY_EXHAUSTED_FAILURE = "saga/FETCH_NEARLY_EXHAUSTED_FAILURE";
export const FETCH_NEARLY_EXHAUSTED_TODAY = "saga/FETCH_NEARLY_EXHAUSTED_TODAY";
export const FETCH_NEARLY_EXHAUSTED_TODAY_SUCCESS = "saga/FETCH_NEARLY_EXHAUSTED_TODAY_SUCCESS";
export const FETCH_NEARLY_EXHAUSTED_TODAY_FAILURE = "saga/FETCH_NEARLY_EXHAUSTED_TODAY_FAILURE";
export const FETCH_PIF_RENEWAL_TODAY = "saga/FETCH_PIF_RENEWAL_TODAY";
export const FETCH_PIF_RENEWAL_TODAY_SUCCESS = "saga/FETCH_PIF_RENEWAL_TODAY_SUCCESS";
export const FETCH_PIF_RENEWAL_TODAY_FAILURE = "saga/FETCH_PIF_RENEWAL_TODAY_FAILURE";
export const FETCH_MEMBERSHIP_UPGRADES_TODAY = "saga/FETCH_MEMBERSHIP_UPGRADES_TODAY";
export const FETCH_MEMBERSHIP_UPGRADES_TODAY_SUCCESS = "saga/FETCH_MEMBERSHIP_UPGRADES_TODAY_SUCCESS";
export const FETCH_MEMBERSHIP_UPGRADES_TODAY_FAILURE = "saga/FETCH_MEMBERSHIP_UPGRADES_TODAY_FAILURE";
export const FETCH_INTROS_EXPIRED = "saga/FETCH_INTROS_EXPIRED";
export const FETCH_INTROS_EXPIRED_SUCCESS = "saga/FETCH_INTROS_EXPIRED_SUCCESS";
export const FETCH_INTROS_EXPIRED_FAILURE = "saga/FETCH_INTROS_EXPIRED_FAILURE";

// const axios = defaultNetworkService()
export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA),
  fetchFollowUps: createAction(FETCH_FOLLOW_UPS)
};
export default function* watchFollowUps() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeLatest(FETCH_FOLLOW_UPS, getFollowUps);
}

let date;

export function* getCurrentUserData(data) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: data.payload.user });

  date = data.payload.date || (yield select(state => state.followUp.currentUser.calendarEndDate));

  const id = yield select(state => state.followUp.currentUser.organization_id);
  const objectId = yield select(state => state.followUp.currentUser.current_object_id);
  const locationId = yield select(state => state.followUp.currentUser.current_location_id);
  const regionId = yield select(state => state.followUp.currentUser.current_region_id);
  const permissions = yield select(state => state.followUp.currentUser.permissions);

  const allSagas = [getFollowUps(id, objectId, locationId, regionId, date)];
  if (permissions.dashboard_nearly_exhausted_class_packages_module) {
    allSagas.push(getNearlyExhausted(id, objectId, locationId, regionId, date));
  }

  if (permissions.dashboard_visitors_today_list_module) {
    allSagas.push(getNearlyExhaustedToday(id, objectId, locationId, regionId, date));
  }

  if (permissions.dashboard_pif_renewals_module) {
    allSagas.push(getPifRenewalToday(id, objectId, locationId, regionId, date));
  }

  if (permissions.dashboard_membership_upgrades_module) {
    allSagas.push(getMembershipUpgradesToday(id, objectId, locationId, regionId, date));
  }
  if (permissions.dashboard_intros_expiring_module) {
    allSagas.push(getIntrosExpired(id, objectId, locationId, regionId, date));
  }
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData(month) {
  yield put({ type: SET_LOADING, payload: true });

  date = month.payload;

  const id = yield select(state => state.followUp.currentUser.organization_id);
  const objectId = yield select(state => state.followUp.currentUser.current_object_id);
  const locationId = yield select(state => state.followUp.currentUser.current_location_id);
  const regionId = yield select(state => state.followUp.currentUser.current_region_id);
  const permissions = yield select(state => state.followUp.currentUser.permissions);

  const allSagas = [getFollowUps(id, objectId, locationId, regionId, date)];
  if (permissions.dashboard_nearly_exhausted_class_packages_module) {
    allSagas.push(getNearlyExhausted(id, objectId, locationId, regionId, date), getNearlyExhaustedToday(id, objectId, locationId, regionId, date));
  }

  if (permissions.dashboard_pif_renewals_module) {
    allSagas.push(getPifRenewalToday(id, objectId, locationId, regionId, date));
  }

  if (permissions.dashboard_membership_upgrades_module) {
    allSagas.push(getMembershipUpgradesToday(id, objectId, locationId, regionId, date));
  }
  if (permissions.dashboard_intros_expiring_module) {
    allSagas.push(getIntrosExpired(id, objectId, locationId, regionId, date));
  }
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getFollowUps(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "follow_ups/clients_with_no_visits_after_intro" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&start_date=" +
        date
    );
    yield put({ type: FETCH_FOLLOW_UPS_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_FOLLOW_UPS_FAILURE, error });
  }
}

export function* getNearlyExhausted(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "follow_ups/clients_with_nearly_exhausted_class_packages" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&start_date=" +
        date
    );
    yield put({ type: FETCH_NEARLY_EXHAUSTED_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_NEARLY_EXHAUSTED_FAILURE, error });
  }
}

export function* getNearlyExhaustedToday(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "follow_ups/visitors_today_list" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&start_date=" +
        date
    );
    yield put({ type: FETCH_NEARLY_EXHAUSTED_TODAY_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_NEARLY_EXHAUSTED_TODAY_FAILURE, error });
  }
}

export function* getPifRenewalToday(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "follow_ups/pif_renewal_today" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&start_date=" +
        date
    );
    yield put({ type: FETCH_PIF_RENEWAL_TODAY_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_PIF_RENEWAL_TODAY_FAILURE, error });
  }
}

export function* getMembershipUpgradesToday(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "follow_ups/clients_with_membership_upgrades_available" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&start_date=" +
        date
    );
    yield put({ type: FETCH_MEMBERSHIP_UPGRADES_TODAY_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_MEMBERSHIP_UPGRADES_TODAY_FAILURE, error });
  }
}

export function* getIntrosExpired(id, objectId, locationId, regionId, date) {
  try {
    const res = yield call(
      axios.get,
      queryParams.apiVersion +
        "follow_ups/clients_with_expiring_intros" +
        "?organization_id=" +
        id +
        "&location_id=" +
        locationId +
        "&region_id=" +
        regionId +
        "&object_id=" +
        objectId +
        "&start_date=" +
        date
    );
    yield put({ type: FETCH_INTROS_EXPIRED_SUCCESS, payload: res.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_INTROS_EXPIRED_FAILURE, error });
  }
}
